import * as React from 'react';
import { type TabActivityState, claimTabIndicator } from '../../../../utils/tabActivityIndicator';

export type BrandingTabActivity = 'off' | 'branding' | 'done' | 'failed';

const BRANDING_CLAIM = 'social-branding';

export function useBrandingTabIndicator(activity: BrandingTabActivity) {
	const holdsClaimRef = React.useRef(false);

	const claim = React.useCallback((state: TabActivityState | null) => {
		if (state === null && !holdsClaimRef.current) {
			return;
		}
		holdsClaimRef.current = state !== null;
		claimTabIndicator(BRANDING_CLAIM, state);
	}, []);

	const previousActivityRef = React.useRef<BrandingTabActivity>('off');

	React.useEffect(() => {
		const wasBranding = previousActivityRef.current === 'branding';
		previousActivityRef.current = activity;

		if (activity === 'branding') {
			claim('generating');
			return;
		}
		if (!wasBranding || activity === 'off' || !document.hidden) {
			claim(null);
			return;
		}

		claim(activity === 'failed' ? 'error' : 'complete');
		const handleReturnToTab = () => {
			if (!document.hidden) {
				claim(null);
			}
		};
		document.addEventListener('visibilitychange', handleReturnToTab);
		window.addEventListener('focus', handleReturnToTab);
		return () => {
			document.removeEventListener('visibilitychange', handleReturnToTab);
			window.removeEventListener('focus', handleReturnToTab);
		};
	}, [activity, claim]);

	React.useEffect(() => () => claim(null), [claim]);
}
